const freeEmailProviders = [
	'gmail.com',
	'yahoo.com',
	'hotmail.com',
	'outlook.com',
	'aol.com',
	'icloud.com',
	'mail.com',
	'protonmail.com',
	'zoho.com',
	'yandex.com',
	'live.com',
	'inbox.com',
	'gmx.com',
];

const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function validateEmailForCompany(email) {
	if (!email) {
		return {
			isValid: false,
			message: 'Email is required',
		};
	}
	if (!emailRegex.test(email)) {
		return {
			isValid: false,
			message: 'Invalid email',
		};
	}
	// Extract domain from email
	const domain = email.split('@')[1].toLowerCase();

	// Check if the domain is not in the list of free email providers
	if (freeEmailProviders.includes(domain)) {
		return {
			isValid: false,
			message: 'Please use a company email.',
		};
	}
	return {
		isValid: true,
		message: 'Valid company email',
	};
}

exports.validateEmailForCompany = validateEmailForCompany;
